/*
  7Raw "Find a boutique" region tabs: <r7-boutique-tabs> (sections/7r-boutiques.liquid, 06 §6.3 and §9).
  - WAI-ARIA tabs with automatic activation: a click, or ←/→ (wrapping) and Home/End with focus on the
    tab list, selects a region and swaps its panel in at once (no fade, no scroll).
  - Selected tab: aria-selected="true", tabindex 0 and .r7-on-bone (bone focus ring, 08 A08-7);
    the others: aria-selected="false", tabindex -1. Every panel but the selected one is [hidden].
  - Theme editor: selecting a region block selects its tab.
  - Reconnecting rebuilds the state from the markup (the selected tab wins) and drops old listeners.
*/
if (!customElements.get('r7-boutique-tabs')) {
  customElements.define(
    'r7-boutique-tabs',
    class R7BoutiqueTabs extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();

        this.list = this.querySelector('[role="tablist"]');
        this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
        this.panels = this.tabs.map((tab) => document.getElementById(tab.getAttribute('aria-controls')));
        if (!this.list || !this.tabs.length) return;

        const current = this.tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
        this.selected = -1;
        this.select(Math.max(current, 0));

        this.controller = new AbortController();
        const { signal } = this.controller;

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(index), { signal });
        });

        this.list.addEventListener('keydown', (event) => this.onKeydown(event), { signal });

        this.addEventListener(
          'shopify:block:select',
          (event) => {
            const index = this.tabs.indexOf(event.target.closest('[data-tab]'));
            if (index !== -1) this.select(index);
          },
          { signal }
        );
      }

      disconnectedCallback() {
        this.controller?.abort();
      }

      onKeydown(event) {
        const index = this.tabs.indexOf(event.target.closest('[data-tab]'));
        if (index === -1) return;

        const last = this.tabs.length - 1;
        let target;
        if (event.key === 'ArrowRight') target = index === last ? 0 : index + 1;
        else if (event.key === 'ArrowLeft') target = index === 0 ? last : index - 1;
        else if (event.key === 'Home') target = 0;
        else if (event.key === 'End') target = last;
        else return;

        event.preventDefault();
        this.select(target);
        this.tabs[target].focus();
      }

      select(index) {
        if (index === this.selected) return;
        this.selected = index;

        this.tabs.forEach((tab, i) => {
          const on = i === index;
          tab.setAttribute('aria-selected', String(on));
          tab.tabIndex = on ? 0 : -1;
          tab.classList.toggle('r7-on-bone', on);
        });

        this.panels.forEach((panel, i) => {
          if (panel) panel.hidden = i !== index;
        });
      }
    }
  );
}
